import { useEffect, useState } from "react";

const EVENT_DATE = new Date("2026-10-25T10:00:00+02:00");

const pad = (n) => String(n).padStart(2, "0");

const Countdown = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = EVENT_DATE.getTime() - now;

  if (diff <= 0) {
    return (
      <div className="inline-flex items-center rounded-2xl border border-[#E30613]/30 bg-white/80 px-6 py-4 shadow-sm backdrop-blur-sm" data-testid="countdown-container">
        <span className="font-display text-lg font-semibold uppercase tracking-[0.1em] text-[#E30613]">L'Open Day è in corso!</span>
      </div>
    );
  }

  const units = [
    { v: Math.floor(diff / 86400000), l: "Giorni", testId: "countdown-days" },
    { v: Math.floor(diff / 3600000) % 24, l: "Ore", testId: "countdown-hours" },
    { v: Math.floor(diff / 60000) % 60, l: "Minuti", testId: "countdown-minutes" },
    { v: Math.floor(diff / 1000) % 60, l: "Secondi", testId: "countdown-seconds" },
  ];

  return (
    <div className="inline-flex flex-col gap-3 rounded-2xl border border-[#ECECEA] bg-white/80 px-7 py-5 shadow-sm backdrop-blur-sm" data-testid="countdown-container">
      <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#E30613]">Manca poco all'Open Day</span>
      <div className="flex items-start gap-5">
        {units.map((u, i) => (
          <div key={u.l} className="flex items-start gap-5">
            {i > 0 && <span className="pt-2 font-display text-2xl font-semibold text-[#E30613]/50">:</span>}
            <div className="text-center">
              <div className="font-display text-3xl font-semibold tabular-nums text-[#232525] sm:text-4xl" data-testid={u.testId}>
                {pad(u.v)}
              </div>
              <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-[#8A8C8A]">{u.l}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
